// eslint-disable-next-line import/no-unresolved
// import keenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'
/* eslint-disable import/no-unresolved */
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { config } = window.BAO.Carousel
const { setInitialised } = window.BAO.Carousel.plugins
const preBuyUtils = new window.PreBuyUtils()

class ProductCard extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  async connectedCallback () {
    super.connectedCallback()

    if (this.els?.slide?.elements?.length < 2) return

    this.carousel = this.setupCarousel()

    this.peekProductCards()

    this.checkPreBuy()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.label?.exists && this.els?.button?.exists) {
      this.els.button.elements.forEach(buttonEl => {
        this.listeners.add(
          buttonEl,
          'mouseenter',
          this.handleMouseEnter.bind(this),
        )
        this.listeners.add(
          buttonEl,
          'mouseleave',
          this.handleMouseLeave.bind(this),
        )
      })
    }

    if (this.els?.button?.exists) {
      this.els.button.elements.forEach(buttonEl => {
        this.listeners.add(buttonEl, 'click', this.handleButtonClick.bind(this))
      })
    }
  }

  handleButtonClick (e) {
    e.stopPropagation()
    if (e.target.tagName === 'A') return
    e.preventDefault()
  }

  handleMouseEnter (e) {
    if (e?.currentTarget?.dataset?.variantAvailable === 'true') {
      if (e?.currentTarget?.dataset?.preorder === 'true') {
        this.els.label.element.textContent = window.theme.strings.preOrder
      } else {
        this.els.label.element.textContent = window.theme.strings.addToCart
      }
    } else {
      this.els.label.element.textContent = window.theme.strings.notifyMe
    }
  }

  handleMouseLeave (e) {
    this.els.label.element.textContent = this.dataset.colour
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.classList.toggle(
        this.config.classes.mediaSlideActiveClass,
        index === currentSlide,
      )
    })
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'snap',
        defaultAnimation: {
          duration: config.defaultAnimation.duration,
        },
        dragSpeed: config.dragSpeed,
        slides: {
          perView: 1,
        },
        slideChanged: this.onSlideChanged,
      },
      [setInitialised()],
    )
  }

  peekProductCards () {
    if (window.BAO.Utils.getLocalStorage('BAO-card-peek')) return

    const productCard1 = document.querySelector(
      '.prd-List_Items .prd-List_Item:nth-child(1)',
    )
    const productCard1Slides =
      productCard1.querySelector('.prd-Card_Slides').children.length || 0

    const productCard2 = document.querySelector(
      '.prd-List_Items .prd-List_Item:nth-child(2)',
    )
    const productCard2Slides =
      productCard2.querySelector('.prd-Card_Slides').children.length || 0

    if (productCard1 === null) return

    // eslint-disable-next-line compat/compat
    const observer = new IntersectionObserver(entry => {
      if (entry[0].intersectionRatio !== 0) {
        if (productCard1Slides > 1) {
          setTimeout(() => {
            productCard1.classList.add('prd-List_Item-animate')
          }, 1500)
        }

        if (productCard2 === null || productCard2Slides < 2) return

        setTimeout(() => {
          productCard2.classList.add('prd-List_Item-animate')
        }, 2500)

        // 1 day in milliseconds.
        window.BAO.Utils.setLocalStorage('BAO-card-peek', 'true', 86400000)
      }
    })

    observer.observe(productCard1)
  }

  checkPreBuy () {
    const addToCartButtons = this.els.button?.elements
    if (!addToCartButtons) return

    addToCartButtons.forEach(async el => {
      if (el.dataset.checkPreBuy === undefined) return
      const productId = el.dataset?.productId
      const variantId = el.dataset?.variantId

      if (!productId || !variantId) return

      const preBuyData = await preBuyUtils.getPreBuyData(productId, variantId)

      if (preBuyData.quantityAvailable > 0 && !preBuyData.inventoryAvailable) {
        return
      }

      if (preBuyData?.enabled && !preBuyData?.variantPool) {
        el.disabled = true
        el.classList.add('prd-Card_Button-disabled')
      }
    })
  }

  get config () {
    return {
      classes: {
        mediaSlideActiveClass: 'sec-FeaturedProducts_Slide-active',
      },
    }
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard, {
    extends: 'article',
  })
}
